import { render, staticRenderFns } from "./coursedetail.html?vue&type=template&id=2a8b82e4&scoped=true&"
import script from "./coursedetail.js?vue&type=script&lang=js&"
export * from "./coursedetail.js?vue&type=script&lang=js&"
import style0 from "./coursedetail.css?vue&type=style&index=0&id=2a8b82e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b82e4",
  null
  
)

export default component.exports